// extracted by mini-css-extract-plugin
export default {"cover":"bxBQ6OK3uzcifzMzaSez","mask":"OXvdiWDAp0alucjVTHG4"};